export default
    {
        // 注销
        async logOutNum(params) {
            let actiontype = 'applyDropUserInfo';
            return await this.fetch(actiontype, params);
        },
        // app-登录
        async appAutoLogin(params) {
            let actiontype = 'AccountService_UserLoginByToken';
            return await this.fetch(actiontype, params);
        },
        async dpUserDetailInfo(params) {
            let actiontype = 'AccountService_UserDetailInfo';
            return await this.fetch(actiontype, params);
        }
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/user.js